<template>
	<div class="container priorities">
		<div class="row justify-content-md-center">
			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="user-secret" class="info" /> {{view_nome}}
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="sign-out-alt" class="atencao" /> Ocupado
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="sign-in-alt" class="verde" /> Atendida
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="times" class="vermelho" /> Não atendida
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="times" class="info" /> Abandonada
			</div>

			<div class="col-sm-6 col-md-4 col-xl-2">
				<font-awesome-icon icon="retweet" class="laranja" /> Transbordo
			</div>
		</div>
	</div>
</template>

<script>
	export default { 
		name: "call-type", 

		computed: {
			view_nome(){ 
				return this.$store.state.config_view_menu.denuncia_detalhe;
			}
		}
	}
</script>

<style>
	.priorities {
		margin-bottom: 5px;
	}
</style>